import React from "react";
const InsiderLinkContext = React.createContext({
    searchParams: ""
});
export default InsiderLinkContext;
